module.exports = __webpack_public_path__ + "media/react/assets/imgs/signin-f2c580a7008ac77e1a0ac3e498699381.png";